// extracted by mini-css-extract-plugin
export default {"folderManager":"FolderManager_folderManager__ksN4o","folderGrid":"FolderManager_folderGrid__8-rcy"};